<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="accountCategory== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/invoices']" (click)="onCloseInvoiceView()" class="text-secondary"> Invoices</a></small>
    <small *ngIf="accountCategory== 'DEALER'"><a [routerLink]="['/dealer']" class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/invoices']" (click)="onCloseInvoiceView()" class="text-secondary"> Invoices</a></small>
    <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
        class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/invoices']" (click)="onCloseInvoiceView()" class="text-secondary"> Invoices</a></small>
    <small *ngIf="accountType== 'VEHICLE_SERVICE_PROVIDER'"><a [routerLink]="['/service-provider/dashboard']"
        class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/invoices']" (click)="onCloseInvoiceView()" class="text-secondary"> Invoices</a></small>
    <small *ngIf="accountCategory== 'CORPORATE' || accountCategory == 'FINANCING_GROUP'"><a [routerLink]="['/corporate']" class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/invoices']" (click)="onCloseInvoiceView()" class="text-secondary"> Invoices</a></small>
    <small *ngIf="viewInvoice">
      /&nbsp;<a class="text-secondary">{{selectedInvoice.invoiceNumber}}</a>
    </small>
  </div>
</div>

<div class="row pt-2 no-gutters">
  <div class="col-12 text-right" *ngIf="!viewInvoice">
    <button class="btn btn-primary border btn-153" data-toggle="modal" data-target="#billing" data-backdrop="static"
      (click)="billingProfile.getBillingProfile()" data-keyboard="false">Billing Profile</button>
    <button *ngIf="showPaymentProfile" class="btn btn-primary border btn-153 ml-1" data-toggle="modal" data-target="#paymentSettingsModal" data-backdrop="static"
      data-keyboard="false" (click)="paymentSettingsComponent.getAccountPaymentSetting()">Payment Profile</button>
  </div>
</div>

<payment-settings #paymentSettingsComponent></payment-settings>

<app-account-billing-profile #billingProfile></app-account-billing-profile>

<view-invoice-list [invoices]="invoices" (selectedInvoiceEmitter)="onInvoiceSelected($event)"
  (onPaymentStatusEmitter)="getInvoices()" #invoiceListComponent></view-invoice-list>